export default {"src":"/_next/static/media/celo.44511272.svg","height":950,"width":950,"blurWidth":0,"blurHeight":0};